import React, { FC } from 'react';
import { Route } from "react-router-dom";
import { useSelector } from 'react-redux';
import { selectLogStatus } from '../../../store/userSlice';　
import getRootPath from '../../../utils';

interface AuthTouteProps {
    path: string,
    exact: boolean,
    component: FC,
    auth: boolean,
}

const AuthRoute: any = (props: AuthTouteProps) => {
    const { path, exact, component, auth } = props;
    const isLogin = useSelector(selectLogStatus);         //获取用户当前是否登录的状态
    // 如果路由不需要鉴权
    if(!auth){
        return <Route path={path} exact={exact} component={component}></Route>
    } else {
        // 需要鉴权，且已登录
        if( isLogin ){
            return <Route path={path} exact={exact} component={component}></Route>
        } else {
            // 需要鉴权，未登录
            const redirectURL = getRootPath();
            window.location.href = `/cas/login?service=${encodeURIComponent(redirectURL)}`
            return null;
        }
    }
};

export default AuthRoute;

